export { default as Footer} from './Footer';



// WEBPACK FOOTER //
// ./src/components/Footer/index.js